import {useMutation} from "@tanstack/react-query";
import {apiUploadFile} from "../../../data/api/file";

export const useUploadFile = () => {
    return useMutation({
        mutationFn: async ({file, onProgress}) =>{
            return apiUploadFile(file, onProgress);
        }

    })
}